module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": _vm.type,
      "picker-options": _vm.pickOptions,
      "editable": false,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39205f68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/libs/ClientFramework/packages/basicElement/datebox/dateTimeBox.vue
// module id = 921
// module chunks = 80